// extracted by mini-css-extract-plugin
export default {"pageLayout":"AdminEnrollmentManagement-module__pageLayout___WuSLD"};